import { handleCreateBooking } from "../../../redux/member-slices/bookings.slice";
import { hideDialog, refresher } from "../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import InputFieldB from "../../ui/InputFieldB";
import Icons from "../../../assets/js/Icons";

import { Alert, Button, Checkbox, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

function Booking() {
  const dispatch = useDispatch();
  const accessToken = useRef(null);
  const tokenClientRef = useRef(null);
  const { data } = useSelector((state) => state.otherSlice);
  const { member, specialist } = useSelector((state) => state.authSlice);
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState("");

  // Handle user signup
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    formData.webinarId = data?.webinarId;
    formData.reminder = Boolean(formData.reminder);
    formData.accessToken = accessToken.current;
    formData.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const res = await dispatch(handleCreateBooking(formData));
    if (res?.error) {
      setErrorMsg(res?.error?.message || res?.payload || "To watch or book webinars, please purchase a subscription plan.");
    } else {
      setTimeout(() => {
        handleClose();
        dispatch(refresher());
      }, 500);
    }
  };

  const handelCalendarRemoinder = async (e) => {
    if (e.target.checked) {
      tokenClientRef?.current?.requestAccessToken();
    }
  };

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog());
  };

  useEffect(() => {
    if (window.google && window.google.accounts) {
      tokenClientRef.current = window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        scope: "https://www.googleapis.com/auth/calendar.events",
        callback: (response) => {
          accessToken.current = response?.access_token;
        },
      });
    }
  }, []);

  return (
    <Paper component="form" onSubmit={handleSubmit}>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          Webinar Booking
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "black",
            position: "absolute",
            bgcolor: "#0000001f !important",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <Stack spacing={2}>
          {errorMsg && (
            <Stack spacing={1.5} alignItems="center" mb={1}>
              <Alert severity="warning" sx={{ width: "100%" }}>
                {errorMsg}
              </Alert>
              <Button
                variant="contained"
                onClick={() => {
                  handleClose();
                  navigate("/pricing");
                }}
                sx={{ bgcolor: "#2F4250", color: "#fff", "&:hover": { bgcolor: "#22313D" } }}
              >
                Purchase Subscription
              </Button>
            </Stack>
          )}
          <InputFieldB
            disabled
            label="full name"
            variant="outlined"
            placeholder="Enter your full name"
            defaultValue={member?.fullName || specialist?.specialist?.fullName || specialist?.fullName}
          />
          <InputFieldB
            disabled
            label="email"
            variant="outlined"
            placeholder="Enter your email"
            defaultValue={member?.email || specialist?.specialist?.email || specialist?.email}
          />
          <FormControlLabel
            sx={{
              ".MuiButtonBase-root": { p: 0, pr: 1 },
              ".MuiTypography-root": { fontSize: 14 },
            }}
            name="reminder"
            onChange={handelCalendarRemoinder}
            control={<Checkbox value={true} />}
            label="Add to my calendar with personalized reminders"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, justifyContent: "center" }}>
        <Button type="submit" variant="contained">
          Book now
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default Booking;
